import PropTypes from 'prop-types'
import { TextField } from '@mui/material'
import { TextBody } from 'components'
import { InputContainer, InputLabel, StyledTextField } from './Input.styled'

const Input = ({
  label,
  type = 'text',
  name,
  placeholder,
  value,
  onChange,
  error,
  helperText,
  fullWidth = true,
  margin = 'normal',
  variant = 'outlined',
  required = false,
  disabled = false,
  className,
  mb,
  maxLength,
  autoComplete,
  ...rest
}) => {
  const handleInputChange = e => {
    const { value } = e.target

    // Handle number type input
    if (type === 'number') {
      if (!/^\d*$/.test(value) || (maxLength && value.length > maxLength)) {
        return
      }
    }

    onChange(e)
  }

  return (
    <InputContainer mb={mb} className={className}>
      {label && (
        <InputLabel>
          <TextBody variant="subtitle" fontWeight={600}>
            {label}
            {required && !value && <span style={{ color: 'red' }}> *</span>}
          </TextBody>
        </InputLabel>
      )}
      <StyledTextField>
        <TextField
          name={name}
          type={type === 'number' ? 'text' : type}
          inputMode={
            type === 'number' ? 'numeric' : type === 'email' ? 'email' : 'text'
          }
          placeholder={placeholder}
          fullWidth={fullWidth}
          margin={margin}
          variant={variant}
          value={value}
          onChange={handleInputChange}
          error={!!error}
          helperText={error || helperText}
          required={required}
          disabled={disabled}
          autoComplete={autoComplete}
          inputProps={{
            ...rest.inputProps,
            maxLength: maxLength,
            pattern: type === 'number' ? '[0-9]*' : undefined
          }}
          {...rest}
        />
      </StyledTextField>
    </InputContainer>
  )
}

Input.propTypes = {
  label: PropTypes.string,
  type: PropTypes.oneOf(['text', 'email', 'password', 'number', 'tel', 'url']),
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  helperText: PropTypes.string,
  fullWidth: PropTypes.bool,
  margin: PropTypes.oneOf(['none', 'dense', 'normal']),
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled']),
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  mb: PropTypes.string,
  maxLength: PropTypes.number,
  autoComplete: PropTypes.string
}

export default Input
